module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble",
      "lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "role": "doc-pagebreak",
      "title": "1"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title",
      "lang": "en-US"
    }
  }, [_c('span', [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "auteur",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Todd Hunter")]), _vm._v(" "), _c('div', {
    staticClass: "chapeau"
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "fig-002",
      "role": "presentation",
      "src": "images/p1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("L")]), _vm._v("ife is sheer gift. But being alive involves us in a mysterious jumble. We experience our actual lives as grace and goodness intertwined with sinning and being sinned against. Beauty and evil stand together knocking on the doors of our heart and our soul. The bad stuff seems louder, campaigning against our will and emotions with a ferocity that would make even a DC lobbyist blush.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This means that having a life—at least having a meaningful, purposeful life directed at "), _c('i', [_vm._v("God’s good")]), _vm._v("—is often a test, occasionally involving painful trials. We know this by experience.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("For many of us, the challenge becomes too much. We find ways to retire from “seeking first the kingdom of God.” We invent ways to no longer hear Jesus’ invitation to “come follow me.” We refuse to look across the road, for we might see a Samaritan in need. We learn that it is easier and culturally normative to reject, despise, or condemn an enemy rather than to love him or her, to actively direct our will to seek their good. This is the broad road that leads to destruction.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "role": "doc-pagebreak",
      "title": "2"
    }
  }, [_vm._v("But another way stands open before us: following the way of Jesus on the narrow path.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Jesus way requires seeking, within a participative community, a well-ordered life. These are the great insights Jared Boyd brings together in the Order of the Common Life, a missional monastic order. Having done a postulancy cohort led by Jared, I learned some things about the spiritual growth that comes from a community ordered around spiritual transformation into Christlikeness for the sake of being ambassadors of God’s kingdom, agents of his healing and redemptive love.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Thankfully with the publishing of "), _c('i', [_vm._v("Finding Freedom in Constraint, ")]), _vm._v("you can get both insight into and a taste of the possibilities of a well-ordered life. But be prepared for surprising revelations, for counterintuitive insights along the ancient and sacred path to spirituality in the way of Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In my postulancy cohort, I was given an environment in which I deepened my ability to notice the love of God and to nurture receptivity to it. I was given the gift of space to reimagine my vocation to follow Jesus for the sake of others. I learned, again, that information and content alone are not transformative, that engaging my will and engaging with a community are vital to real, lasting transformation. I discerned where I felt trapped by an over-full life and discovered an appropriate rhythm of life for someone in their late sixties. I could go on for pages with highlights from my journal.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The power of good questions. The gift of being listened to. The sense of the presence of God. All of this, even when striving to look deeply within, was hopeful and pleasant. It was not a legalistic grind or religious chore. Rather, I found myself being organically more peacefully present to life.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "role": "doc-pagebreak",
      "title": "3"
    }
  }, [_vm._v("Over our months together as a cohort I found myself wishing that others could experience this too. With the publication of this book, now you can receive an orientation to what a well-ordered life in a community seeking transformation looks and feels like.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jared is wise. He knows, as Jesus taught, that wheat and weeds grow in the world until the final judgment, and that Jesus is superintending this reality. For our purposes in this book, it is crucial to note that weeds do not just grow in the world outside us, they grow with the good wheat in our hearts and souls too.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This can be frightening. It can lead to lots of harmful self-talk, to dysfunctional feelings of guilt, or worse, to sibilating shame. I want to ask you to trust that God knows what he is doing in your life, just as he knows what is happening in the world. Don’t try to get ahead of God, don’t try to hurry the pace of transformation. God is patient with weeds that remain. Just gently and peacefully keep seeking first Jesus and the kingdom of God.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As you begin to turn the pages to hear Jared’s voice, I want you to relax. A well-ordered life that others experience as for their good awaits you as you practice what Jared teaches: the intelligent, grace-based practices of ancient and anointed Christian spirituality.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30c2cce0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre1.vue
// module id = 66
// module chunks = 0